/**
 * @generated SignedSource<<d6b094e4e440ac4ec45ef99a48b4f9ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestGroupSizeControlNode$data = {
  readonly __typename: "QueueSlot";
  readonly capacity: number;
  readonly id: string;
  readonly " $fragmentType": "RequestGroupSizeControlNode";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "RequestGroupSizeControlNode";
};
export type RequestGroupSizeControlNode$key = {
  readonly " $data"?: RequestGroupSizeControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestGroupSizeControlNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestGroupSizeControlNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        }
      ],
      "type": "QueueSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "c638030073bc7c68f2f596bb87398aea";

export default node;
